// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"23237ecc","228":"434dc32e","251":"dabef1ce","272":"b1b290dc","354":"fbf97a90","438":"51cf4b10","479":"3cf51ad5","488":"8f270229","536":"f239cb49","602":"cfa0924c","703":"b7227f26","829":"972a36e6","837":"d5e669b6"}[chunkId] + ".chunk.js";
};